import React from "react";
import SoftBox from "components/SoftBox";
import LogoUpload from "./LogoUpload";
import SettingsCard from "./SettingsCard";

const BrandLogosSection = ({
  logo,
  previewLogo,
  Auth_logo,
  previewAuthLogo,
  Footer_logo,
  previewFooterLogo,
  Meta_logo,
  previewMetaLogo,
  handleImageUpload,
  inputData
}) => {
  return (
    <SettingsCard
      title="Brand Logos"
      subtitle="Upload and manage your brand logos"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)",
            marginRight: "24px"
          }
        }
      }}
    >
      <SoftBox
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          flexWrap: "wrap",
          gap: { xs: 2, sm: 1.5 },
          rowGap: { xs: 2, sm: 2.5 },
          width: "100%"
        }}
      >
        <LogoUpload
          title="Header Logo"
          value={logo}
          previewValue={previewLogo}
          defaultValue="https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/fff1c682-9973-4054-afce-285e5b950f05.png"
          name="logo"
          onChange={(e) => handleImageUpload(e, "logo")}
          recommendation="Recommended: (300px x 150px) 2:1 ratio. 1MB size."
          size="large"
        />
        <LogoUpload
          title="Auth Logo"
          value={Auth_logo}
          previewValue={previewAuthLogo}
          defaultValue="https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/a742c392-3573-4833-a324-d6e51090ee28.png"
          name="auth_logo"
          onChange={(e) => handleImageUpload(e, "auth_logo")}
          recommendation="Recommended: (300px x 150px) 2:1 ratio. 1MB size."
          size="small"
        />
        <LogoUpload
          title="Footer Logo"
          value={Footer_logo}
          previewValue={previewFooterLogo}
          defaultValue="https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/b5738fa2-b05a-46db-a2c2-0c0612c76ae2.png"
          name="footer_logo"
          onChange={(e) => handleImageUpload(e, "footer_logo")}
          recommendation="Recommended: (300px x 150px) 2:1 ratio. 1MB size."
          size="large"
        />
        <LogoUpload
          title="Favicon"
          value={Meta_logo}
          previewValue={previewMetaLogo}
          defaultValue="https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/bd948045-7012-4b81-8dfe-8f585c519511.png"
          name="Meta_logo"
          onChange={(e) => handleImageUpload(e, "Meta_logo")}
          recommendation="Recommended: (192px x 192px) 1:1 ratio. 1MB size."
          size="small"
        />
      </SoftBox>
    </SettingsCard>
  );
};

export default BrandLogosSection;
